"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emotions = void 0;
const createApi_1 = require("../../../helpers/createApi");
/**
 * @description fetch the website mapping analysis from an emotionsAI's mappingId
 * @link https://datadoc.abtasty.com/projects/reporting/api/swagger-ui-staging.html#/EmotionAI/getEmotionsOpportunities
 */
const postOpportunities = (caller) => (options) => {
    const { accountId, payload, useCache = true } = options;
    const url = `/clients/${accountId}/reporting/emotions/opportunities?useCache=${useCache}`;
    return caller(url).post(payload);
};
exports.emotions = (0, createApi_1.createAPIFactory)({
    postOpportunities,
});
//# sourceMappingURL=api.js.map